import { createApp } from 'vue'
import store from './store/store'
import App from './App.vue'
import i18n from '@/i18n'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', component: App },
  { path: '/fr', component: App },
  { path: '/de', component: App },
  { path: '/en', component: App },
  { path: '/it', component: App },
  { path: '/nl', component: App },
]

const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHistory(),
  routes, // short for `routes: routes`
})

const app = createApp(App)

app.use(router)
app.use(i18n)

app.use(store)
app.mount('#app')
